/**
 * Check if the user has a specific permission.
 * @param {string[]} permissions - user's permission array
 * @param {string} permission - e.g. PERMISSION.CONFIGURATOR_PRODUCT_CREATE
 * @returns {boolean}
 */
export function hasPermission(permissions = [], permission) {
  if (!Array.isArray(permissions) || !permission) return false;
  return permissions.includes(permission);
}

/** Normalize permission list from user object (API may use `permission` or `permissions`). */
export function getUserPermissions(user = {}) {
  const list = user?.permission ?? user?.permissions;
  return Array.isArray(list) ? list : [];
}

export { PERMISSION } from "../constants/permissions";
